import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Receipt Text Edit Outline"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-receipt-text-edit-outline',
    templateUrl: './icon-receipt-text-edit-outline.component.html',
    styleUrls: ['./icon-receipt-text-edit-outline.component.scss'],
    standalone: false
})
export class IconReceiptTextEditOutlineComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
